export default function getUsdAmount(amount: number | string = 0) {
  const formattedAmount = Number(amount)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return `$${formattedAmount}`;
}
